import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import omsApi from "../../services/omsapi";
import { BiPrinter } from "react-icons/bi";
import moment from "moment/moment";
function GenerateInvoice() {
  const e = document.getElementById("invoicePrintCapture");
  const t = window.open(
    "",
    "PrintWindow",
    "width=1200,height=650,top=50,left=50,toolbars=no,scrollbars=yes,status=no,resizable=yes"
  );
  t.document.write("<html><head><title>Packing Order Check List</title>");
  t.document.write("</head><body>");
  t.document.writeln(e.innerHTML);
  t.document.write("</body></html>");
  t.document.close();
  t.focus();
  t.print();
  t.close();
  //   html2canvas(document.querySelector("#invoicePrintCapture")).then((canvas) => {
  //     const imgData = canvas.toDataURL("image/png", 1.0);
  //     const pdf = new jsPDF({
  //       orientation: "portrait",
  //       unit: "pt",
  //       format: [612, 792],
  //     });
  //     pdf.internal.scaleFactor = 1;
  //     const imgProps = pdf.getImageProperties(imgData);
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
  //     pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  //     pdf.save("invoicelist.pdf");
  //   });
}

const InvoiceDiv = ({ invoiceDetails }) => {
  const indCurrency = "₹";
  // console.log(invoiceDetails.id,'invoiceDetails');
  return (
    <>
      <div className="p-4 " >
        <Row className="mb-4" style={{ paddingBottom: '5px' }}>
          <Col >
            <Col style={{ display: 'inline-block', width: '100%' }}>
              <div style={{ float: 'left', textAlign: 'left', width: '60%' }}> Invoice #: {invoiceDetails.order_showid || ""} </div>
              <div style={{ float: 'right', textAlign: 'right', width: '40%' }}> Date : {moment(invoiceDetails.order_posteddate).format(
                "YYYY/MM/DD kk:mm:ss"
              ) || ""} </div>
            </Col>
            <div style={{ fontWeight: 'bold' }}>Billed to:</div>
            <div>{invoiceDetails.shipping_name || ""}</div>
            {invoiceDetails.door_flat_no && (
              <div>{invoiceDetails.door_flat_no}</div>
            )}
            <div>{invoiceDetails.shipping_mobile || ""}</div>
            <div>{invoiceDetails.shipping_address || ""}</div>
            <div>{invoiceDetails.shipping_landmark || ""}</div>
            <div>{invoiceDetails.customer_email || ""}</div>
          </Col>
        </Row>
        <Table className="mb-0">
          <thead>
            <tr>
              <th>DESCRIPTION</th>
              <th>QTY</th>
              <th style={{ textAlign: 'right' }}>PRICE</th>
              <th style={{ textAlign: 'right' }}>AMOUNT</th>
            </tr>
          </thead>
          <tbody>
            {invoiceDetails.products.map((item, i) => {
              return (
                <tr id={i} key={i}>
                  <td>
                    {item.name} - {item.unit} {item.unit_type.toLowerCase()}
                  </td>
                  <td style={{ width: "70px" }}>{item.quantity}</td>
                  <td style={{ width: "100px", textAlign: 'right' }}>
                    {indCurrency} {(item.sale_price).toFixed(2)}
                  </td>
                  <td style={{ width: "100px", textAlign: 'right' }}>
                    {indCurrency} {(item.sale_price * item.quantity).toFixed(2)}
                  </td>
                </tr>
              );
            })}
          </tbody>

          <tfoot>
            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            <tr className="text-end">
              <td colSpan={2}></td>
              <td style={{ width: "100px", fontWeight: 'bold' }}>
                SUBTOTAL
              </td>
              <td className="text-end" style={{ width: "100px", textAlign: 'right' }}>
                {indCurrency} {(invoiceDetails.order_subtotal.toFixed(2))}
              </td>
            </tr>

            {invoiceDetails.order_oadisc > 0.0 && (
              <tr className="text-end">
                <td colSpan={2}></td>
                <td className="fw-bold" style={{ width: "100px", fontWeight: 'bold' }}>
                  DISCOUNT
                </td>
                <td className="text-end" style={{ width: "100px", textAlign: 'right' }}>
                  {indCurrency} {(invoiceDetails.order_oadisc).toFixed(2)}
                </td>
              </tr>
            )}
            {Number(invoiceDetails.order_dlvrycharge || 0) > 0 && (
              <tr className="text-end">
                <td colSpan={2}></td>
                <td className="fw-bold" style={{ width: "100px", fontWeight: 'bold' }}>
                  DELIVERY CHARGE
                </td>
                <td className="text-end" style={{ width: "100px", textAlign: 'right' }}>
                  {indCurrency} {Number(invoiceDetails.order_dlvrycharge || 0).toFixed(2)}
                </td>
              </tr>
            )}

            {Number(invoiceDetails.order_smartcart_fee || 0) > 0 && (
              <tr className="text-end">
                <td colSpan={2}></td>
                <td className="fw-bold" style={{ width: "100px", fontWeight: 'bold' }}>
                  SMART CART FEE
                </td>
                <td className="text-end" style={{ width: "100px", textAlign: 'right' }}>
                  {indCurrency} {Number(invoiceDetails.order_smartcart_fee || 0).toFixed(2)}
                </td>
              </tr>
            )}
            <tr className="text-end">
              <td colSpan={2}></td>
              <td className="fw-bold" style={{ width: "100px", fontWeight: 'bold' }}>
                TOTAL
              </td>
              <td className="text-end" style={{ width: "100px", textAlign: 'right' }}>
                {indCurrency} {(invoiceDetails.order_totalamnt).toFixed(2)}
              </td>
            </tr>
          </tfoot>
        </Table>
      </div>
    </>
  );
};

const InvoicePrintModal = ({ invPrintModal, invoiceId, change }) => {
  const [invoiceModal, setInvoiceModal] = useState(invPrintModal);
  const [invoicesList, setInvoicesList] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const handleInvoiceClose = () => {
    setInvoiceModal(false);
    change();
  };
  useEffect(() => {
    setIsLoading(true);
    const fetchOrders = async () => {
      try {
        const data = await omsApi.getOrderPrintList({ orderIds: invoiceId });
        if (data) {
          setInvoicesList(data.data);
          setIsLoading(false);
        }
      } catch (e) {
        console.error("Failed to fetch branch:", e);
      }
    };
    fetchOrders();
  }, [invoiceId]);
  return (
    <div>
      <Modal show={invoiceModal} onHide={handleInvoiceClose} size="lg" centered>
        {isLoading ? (
          "Order detail is loading...."
        ) : (
          <>
            <div id="invoicePrintCapture">
              {invoicesList &&
                invoicesList.map((litem) => (
                  <InvoiceDiv invoiceDetails={litem} />
                ))}
            </div>
            <div className="pb-4 px-4">
              <Row>
                <Col md={6}>
                  <Button
                    variant="danger"
                    className="d-block w-100"
                    onClick={handleInvoiceClose}
                  >
                    Close
                  </Button>
                </Col>
                <Col md={6}>
                  <Button
                    variant="outline-primary"
                    className="d-block w-100 mt-3 mt-md-0"
                    onClick={GenerateInvoice}
                  >
                    <BiPrinter
                      style={{
                        width: "16px",
                        height: "16px",
                        marginTop: "-3px",
                      }}
                      className="me-2"
                    />
                    Print List
                  </Button>
                </Col>
              </Row>
            </div>
          </>
        )}
      </Modal>
      <hr className="mt-4 mb-3" />
    </div>
  );
};

export default InvoicePrintModal;
